module.exports = __webpack_public_path__ + "static/building-cultural-harmony-ce85cf08c95e93c2ff676561f28464e2.png";